import Panel from '../Panel'
import { CheckInSquareIcon } from '../../Icons'
import { Button, Theme } from '@pga/pga-component-library'
import styled from 'styled-components'
import { gql, useQuery } from '@apollo/client'
import { flags, useFeatureFlags } from '../../../lib/feature-flags'
import { shouldShowAnnualSurvey } from '../../utils'
import { COACH_TOOLS_API } from '../../../apolloClient'

export const PDR_HISTORY_QUERY = gql`
  query AnnualSurveyQuery {
    currentPerson {
      id
      pdrHistory {
        id
        activityCode
        description1
      }
    }
  }
`

export function AnnualSurvey ({ me }) {
  const [isAnnualSurveyEnabled] = useFeatureFlags([flags.FLAG_FEAT_ANNUAL_SURVEY])
  const { data } = useQuery(PDR_HISTORY_QUERY, {
    context: {
      api: COACH_TOOLS_API
    }
  })

  const hasAnnualSurveyPdr = data?.currentPerson?.pdrHistory.find(
    (pdr) => pdr.activityCode === 'M281'
  )

  const showAnnualSurvey = isAnnualSurveyEnabled && shouldShowAnnualSurvey(me) && !hasAnnualSurveyPdr

  if (!showAnnualSurvey) {
    return null
  }

  const memberNumber = me.id
  const SURVEY_LINK = `https://pga.surveysparrow.com/s/2026-member-survey/tt-Bd50-?sparrow_unique_id=${memberNumber}`
  return (
    <Panel>
      <ContentWrapper>
        <LeftSection>
          <CheckInSquareIcon />
          <TextContent>
            <StyledTitle>Take the {new Date().getFullYear()} Annual Survey</StyledTitle>
            <StyledDescription>
              Share your thoughts, earn PDRs and help shape the future of the PGA of America.
            </StyledDescription>
            <StyledDescription disclaimer>
              PDR credits will be posted by end of day Tuesday, one week after you submit your survey.
            </StyledDescription>
          </TextContent>
        </LeftSection>
        <StyledButton onClick={() => window.open(SURVEY_LINK, '_blank')} variant='primary'>
          TAKE THE SURVEY
        </StyledButton>
      </ContentWrapper>
    </Panel>
  )
}

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  width: 100%;
  padding: 16px 24px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const StyledTitle = styled.h2`
  font-size: 16px;
  color: ${Theme.colors.black};
  font-weight: 700;
  margin: 0;
  font-family: ${Theme.fonts.PlayfairDisplay};
`

const StyledDescription = styled.p`
  margin: 0;
  font-size: ${props => props.disclaimer ? '10px' : '12px'};
  font-weight: ${props => props.disclaimer ? 600 : 400};
  color: ${Theme.colors.black};
`

const StyledButton = styled(Button)`
  @media (max-width: 768px) {
    width: 100%;
  }
`
